module.exports = __webpack_public_path__ + "static/media/kasriBottom.0d81e0cd.png";